import Validator from 'validatorjs';
/* @ngInject */
export default class ClearanceRequestCtrl {
	constructor($scope, $rootScope, $timeout, ClearanceRequestService, NotificationService, LocalStorageService) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.ClearanceRequestService = ClearanceRequestService;

		this.testObjects = [
			{ id: 1, name: 'Dilip', type: { title: 'a' } },
			{ id: 2, name: 'Devendra', type: { title: 'b' } },
			{ id: 3, name: 'Jayesh', type: { title: 'a' } },
			{ id: 4, name: 'Jekin', type: { title: 'c' } },
			{ id: 5, name: 'Gaurang', type: { title: 'a' } },
			{ id: 6, name: 'Bhavin', type: { title: 'e' } },

		];

		this.init();
		this.activate();
	}

	init() {
		this.isBusy = false;
		this.clearPage();
	}

	activate() {
		this.initializeDatePicker();
	}

	async getAttorneyNames(searchTerm) {
		let attorneyNameResults = await this.ClearanceRequestService.SearchAvailableAttorneyNames(searchTerm);
		console.log(attorneyNameResults);

		attorneyNameResults = [...attorneyNameResults].splice(0,5);

		return attorneyNameResults;
	}

	async submitInitialClearanceRequest() {
		this._switchIsBusy(true);
		try {

			const figuresDate =
				moment(this.ClearanceRequest.FiguresValidUntil).toDate();

			this.ClearanceRequest.FiguresValidUntil = moment(figuresDate).endOf('month').toDate();

			await this.ClearanceRequestService.SaveInitialClearanceRequest(this.ClearanceRequest);
			this.NotificationService.success(
				'Your clearance request has been successfully captured. You should receive correspondence within the next 48 hours.',
				15000
			);
		} catch (error) {
			console.error(error);
			this.NotificationService.error('CLEARANCE REQUEST DETAILS COULD NOT BE SUBMITTED');
		}
		this._switchIsBusy(false);
		this.clearPage();
	}

	initializeDatePicker() {
		this.$timeout(() => {
			const selector = '.date-picker';
			const $input = $(selector, $('#propertyInformation'));
			const dateNow = new Date();

			let startDate = moment(dateNow).startOf('month').add(2, 'M').toDate();

			if (dateNow.getDay() > 15) {
				startDate = moment(startDate).add(1, 'M').toDate();
			}

			const endDate = '+1y';

			const options = {
				startDate,
				endDate,
				container: selector,
				autoclose: true,
				forceParse: true,
				format: "yyyy-mm",
				startView: "months",
				minViewMode: "months"
			};

			$input.datepicker(options);
		});
	}

	clearPage() {
		this.ClearanceRequest = {};
		this.ClearanceRequest.UnitStandNumber = undefined;
		this.ClearanceRequest.SchemeName = undefined;
		this.ClearanceRequest.SellerName = undefined;
		this.ClearanceRequest.PurchaserName = undefined;
		this.ClearanceRequest.FiguresValidUntil = undefined;
		this.ClearanceRequest.AttorneyName = undefined;
		this.ClearanceRequest.AttorneyContactNumber = undefined;
		this.ClearanceRequest.AttorneyEmail = undefined;
		this.ClearanceRequest.AttorneyReference = undefined;
		this.ClearanceRequest.Notes = undefined
	}

	readyForSubmit() {
		this.formsErrors = this.requestValidation();
		if (!this.formsErrors.length) {
			return true;
		}
	}

	requestValidation() {
		let results = [];

		const customErrorMessages = {
			numeric: ':attribute must be a number.',
			required: ':attribute is required.',
			email: ':attribute is not a valid email address.'
		};

		const UnitStandNumber = this.ClearanceRequest.UnitStandNumber,
			SchemeName = this.ClearanceRequest.SchemeName,
			SellerName = this.ClearanceRequest.SellerName,
			FiguresValidUntil = this.ClearanceRequest.FiguresValidUntil,
			AttorneyName = this.ClearanceRequest.AttorneyName,
			AttorneyContactNumber = this.ClearanceRequest.AttorneyContactNumber,
			AttorneyEmail = this.ClearanceRequest.AttorneyEmail,
			AttorneyReference = this.ClearanceRequest.AttorneyReference;

		const inputs = {
			UnitStandNumber,
			SchemeName,
			SellerName,
			FiguresValidUntil,
			AttorneyName,
			AttorneyContactNumber,
			AttorneyEmail,
			AttorneyReference
		};

		const rules = {
			UnitStandNumber: 'required',
			SchemeName: 'required',
			SellerName: 'required',
			FiguresValidUntil: 'required',
			AttorneyName: 'required',
			AttorneyContactNumber: 'required',
			AttorneyEmail: 'required',
			AttorneyReference: 'required'
		};

		const displayLabels = {
			UnitStandNumber: 'Unit /Stand Number',
			SchemeName: 'Property Name',
			SellerName: 'Seller Name(s)',
			FiguresValidUntil: 'Valid Until',
			AttorneyName: 'Attorney Name',
			AttorneyContactNumber: 'Attorney Contact Number',
			AttorneyEmail: 'Attorney Email',
			AttorneyReference: 'Attorney File Reference'
		};

		const validator = new Validator(inputs, rules, customErrorMessages);
		validator.setAttributeNames(displayLabels);

		validator.passes();
		if (validator.errorCount > 0) {
			Object.keys(validator.errors.errors).forEach((name) => {
				const error = validator.errors.first(name);
				results = [...results, error];
			});
		}

		return results;
	}

	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}